import React, { Component } from 'react';
import Firebase from 'firebase';
import { browserHistory } from 'react-router'
import Map from './maps'



class userInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            device: this.props.user.device ? this.props.user.device : null,
            app: this.props.user.version ? this.props.user.version : null,
            registros: this.props.user.pendings ? this.props.user.pendings : null,
            gps: this.props.user.gps ? this.props.user.gps.position.coords : null
        }
    }

    DateToFormattedString(time) {
        var d = new Date(time);
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return (dd[1] ? dd : "0" + dd[0]) + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + yyyy + "   " + (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    };

    render() {
        return (
            <div className="col-md-12">
                <div className="form-group row">
                    <div className="col-md-3">
                        <img src="/img/avatar.png" style={{ width: "120%", border: "1px solid #CCC", padding: "10px" }} />
                    </div>
                    <div className="col-md-9">
                        {
                            this.props.user ?
                                <div style={{ paddingTop: "10px", paddingLeft: "2px" }}>
                                    <h4 style={{ borderBottom: "1px solid #CCC", textIndent: "10px" }}>{this.props.user.name}</h4>
                                    <p style={{ paddingLeft: "20px" }}>
                                        <i className="fa fa-envelope" aria-hidden="true"></i> {this.props.user.email}
                                        <br />
                                        <i className="fa fa-user" aria-hidden="true"></i> {this.props.user.rut}
                                        <br />
                                        <i className="fa fa-phone-square" aria-hidden="true"></i> {this.props.user.number ? this.props.user.number : "No ingresado"}
                                    </p>
                                </div >
                                :
                                ""
                        }
                    </div>
                </div>
                <hr />
                <div className="form-group row">
                    <div className="col-md-6">
                        {
                            this.state.device ?
                                <div className="card">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item"><i className="fa fa-mobile" aria-hidden="true" style={{ fontSize: "20px" }}></i> Smartphone</li>
                                        <li className="list-group-item">Marca: <b style={{ position: "absolute", right: "10%" }}>{this.state.device.brand}</b></li>
                                        <li className="list-group-item">Modelo: <b style={{ position: "absolute", right: "10%" }}>{this.state.device.model}</b> </li>
                                    </ul>
                                </div>
                                :
                                ""
                        }
                        {
                            this.state.app ?
                                <div className="card">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item"><img src="/img/logoIcon.png" style={{ width: "10%" }} /> Aplicación</li>
                                        <li className="list-group-item">App versión: <b style={{ position: "absolute", right: "10%" }}>{this.state.app.app}</b></li>
                                        <li className="list-group-item">App build: <b style={{ position: "absolute", right: "10%" }}>{this.state.app.build}</b> </li>
                                    </ul>
                                </div>
                                : ""
                        }
                        {
                            this.state.registros ?
                                <div className="card">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item"><i className="fa fa-paper-plane" aria-hidden="true"></i> Registros</li>
                                        <li className="list-group-item">Registros pendientes: <b style={{ position: "absolute", right: "10%" }}>{this.state.registros.regs}</b></li>
                                        <li className="list-group-item">Fotos pendientes: <b style={{ position: "absolute", right: "10%" }}>{this.state.registros.photos}</b> </li>
                                    </ul>
                                </div>
                                :
                                ""
                        }
                    </div>
                    <div className="col-md-6">
                        {
                            this.props.user ?
                                <div className="card">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">Fecha de creación: <b style={{ position: "absolute", right: "10%" }}>{this.props.user.created_at ? this.DateToFormattedString(this.props.user.created_at) : "sin información"}</b></li>
                                        <li className="list-group-item">Fecha de modificación: <b style={{ position: "absolute", right: "10%" }}>{this.props.user.modified_at ? this.DateToFormattedString(this.props.user.modified_at) : "sin información"}</b> </li>
                                        <li className="list-group-item">Ultima conexión: <b style={{ position: "absolute", right: "10%" }}>{this.props.user.last_online ? this.DateToFormattedString(this.props.user.last_online) : "sin información"}</b> </li>
                                    </ul>
                                </div>
                                :
                                ""
                        }
                        {
                            this.state.gps ?
                                <div className="card">
                                    <Map lat={this.state.gps.latitude} lon={this.state.gps.longitude} />
                                </div>
                                :
                                ""
                        }
                    </div>
                </div>
            </div >
        );
    }
}
export default userInfo;



// WEBPACK FOOTER //
// ./src/views/users/userInfo.js